import { useEffect, useState } from 'react';
import { listServiceCentersByCompanyId } from '../graphql/companyResourceQueries';
import type { ServiceCenter } from '../types/schema';

export function useCompanyServiceCenters(companyId: string) {
    const [serviceCenters, setServiceCenters] = useState<ServiceCenter[]>([]);
    const [reloadKey, setReloadKey] = useState(0);

    useEffect(() => {
        if (!companyId) {
            setServiceCenters([]);
            return;
        }

        let isCancelled = false;
        (async () => {
            try {
                const data = await listServiceCentersByCompanyId(companyId);
                if (isCancelled) return;
                setServiceCenters(data);
            } catch (err) {
                console.error('Error fetching service centers:', err);
                if (!isCancelled) setServiceCenters([]);
            }
        })();

        return () => {
            isCancelled = true;
        };
    }, [companyId, reloadKey]);

    return {
        serviceCenters,
        reloadServiceCenters: () => setReloadKey((key) => key + 1),
    };
}
